/**
 * Created by lu on 2018/4/8.
 */
module.exports = {
    getParam: function () {
        var params = location.search;
        var pMap = {};
        if (params.indexOf("?") != -1) {
            params = params.substr(1).split("&");
            for (var i = 0; i < params.length; i++) {
                var param = params[i].split('=');
                pMap[param[0]] = param[1];
            }
        }
        return pMap;
    },
    numberFormat: function (number, decimals, dec_point, thousands_sep) {
        /**
         * 参数说明：
         * number：要格式化的数字
         * decimals：保留几位小数
         * dec_point：小数点符号
         * thousands_sep：千分位符号
         * */
        number = (number + '').replace(/[^0-9+-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,

            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.floor(n * k) / k;
            };
        s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
        var re = /(-?\d+)(\d{3})/;
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, "$1" + sep + "$2");
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },
    timeFormat : function (now, split,hasTime) {
        var time = new Date(now);
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var hour = time.getHours();
        var minute = time.getMinutes();
        var second = time.getSeconds();
        if (month < 10) {
            month = '0' + parseInt(month)
        }
        if (date < 10) {
            date = '0' + parseInt(date)
        }
        if (hour < 10) {
            hour = '0' + parseInt(hour)
        }
        if (minute < 10) {
            minute = '0' + parseInt(minute)
        }
        if (split === '/') {
            if(hasTime){
                return year + "/" + month + "/" + date + "  " + hour + ":" + minute;
            }else{
                return year + "/" + month + "/" + date;

            }

        }
        if (split === '-') {
            if(hasTime){
                return year + "年" + month + "月" + date+ "日  " + hour + ":" + minute;
            }else{
                return year + "-" + month + "-" + date;
            }

        }
        return year + "年" + month + "月" + date + "日 ";

    },
    timer : function (inModel, inTime) {
        var countdown = inTime || 60;
        var timeout;
        timeout = setInterval(function () {
            var txt;
            countdown--;
            if (countdown > 0) {
                txt = '获取验证码(' + countdown + 's)';
            } else {
                txt = '获取验证码';
                countdown = inTime || 60;
                inModel.set('disabled', '');
                inModel.set('status', '');
                clearInterval(timeout);
            }
            inModel.set('text', txt);
        }, 1000);
    },
    //倒计时
    endTime : function (inTime,callback) {
        var result;
        var timeout = setInterval(function () {
            var day = 0,
                hour = 0,
                minute = 0,
                second = 0;
            if (inTime > 0) {
                // day = Math.floor(inTime / (60 * 60 * 24));
                // hour = Math.floor(inTime / (60 * 60)) - (day * 24);
                hour = Math.floor(inTime / (60 * 60));
                minute = Math.floor(inTime / 60)- (hour * 60);
                second = Math.floor(inTime)  - (hour * 60 * 60) - (minute * 60);
            }
            if (hour <= 9) hour = '0' + hour;
            if (minute <= 9) minute = '0' + minute;
            if (second <= 9) second = '0' + second;
            inTime--;
            if (inTime >= 0) {
                result =   {
                    timeOut:false,
                    timeMsg:hour + '时:' + minute + '分:' + second + '秒'
                }
            } else {
                clearInterval(timeout);
                result=  {
                    timeOut:true,
                    timeMsg:'00时:00分:00秒  已超时'
                }
            }
            callback(result);
        }, 1000)
    },

    clearCookie:function () {
        $.cookie('asc_b2b_userName','');
        $.cookie('asc_b2b_token','');
        $.cookie('asc_b2b_companyId','');
        $.cookie('asc_b2b_companyType','');
        $.cookie('asc_b2b_userId','');
        $.cookie('asc_b2b_userType','');
        $.cookie('asc_b2b_userState','');
        $.cookie('asc_b2b_onlyWater','');
    },

    //对象添加对象
    toObj:function(key,val){
    var data = {};
    data[key] = val;
    return data;
}
};



//////////////////
// WEBPACK FOOTER
// ../src/js/util.js
// module id = 2
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40